/**
 * ĐO CHIỀU CAO THANH THÔNG BÁO — eGURU 09/09/2026
 *
 * Cả thanh thông báo lẫn header đều dính trên cùng (luật CSS ở
 * assets/custom-third-party.css). Thanh thông báo ghim ở top: 0, header phải
 * ghim ngay DƯỚI nó — mà muốn vậy thì phải biết nó cao bao nhiêu.
 *
 * KHÔNG GHI CỨNG ĐƯỢC CON SỐ: cùng một thanh, máy tính một dòng ~40px, điện
 * thoại chữ gãy ba dòng ~70px; nội dung thông báo lại do người ở Admin gõ nên
 * đổi lúc nào không biết, và thanh này còn xoay vòng nhiều thông báo có độ dài
 * khác nhau. Đo thật rồi đổ vào biến CSS là hết mọi trường hợp đó.
 *
 * ResizeObserver bắt cả ba: đổi cỡ cửa sổ, xoay máy, và thông báo xoay sang câu
 * dài hơn. Không cần nghe sự kiện scroll — chiều cao không đổi theo cuộn.
 *
 * ĐÃ THỬ VÀ ĐÃ BỎ (08/09): dời hẳn thẻ nút đổi ngôn ngữ của T-Lab vào
 * .header__icons cho nó nằm trong header. Chạy được nhưng anh Thắng bác 09/09:
 * "cái phần english là thuộc khung trên cùng của thanh thông báo mà… sao tự ý
 * đổi chỗ phần nút chuyển ngôn ngữ vậy". Nút phải ở nguyên góc phải thanh thông
 * báo; thứ cần dính là CẢ THANH, không phải dời nút đi nơi khác.
 */
(function () {
  'use strict';

  var BIEN = '--eg-cao-thanh-bao';

  function do_() {
    var t = document.getElementById('shopify-section-announcement-bar');
    if (!t) return null;
    var cao = Math.round(t.getBoundingClientRect().height);
    document.documentElement.style.setProperty(BIEN, cao + 'px');
    return t;
  }

  var thanh = do_();
  if (!thanh) return;

  if (window.ResizeObserver) {
    new ResizeObserver(do_).observe(thanh);
  } else {
    window.addEventListener('resize', do_);
  }
})();
